import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function changePassword(data) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/user/changepassword',
        data,
        headers: getApiHeader(),
        withCredentials: true,
    }

    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/changePassword.js